import cn from 'classnames';
import { AudioWaveform } from '@components/editors/audio-waveform.tsx';
import SharedTrascriptAbout from '@components/editors/shared-editor/shared-transcript/shared-transcript-about.tsx';
import { SharedTranscriptBody } from '@components/editors/shared-editor/shared-transcript/shared-transcript-body.tsx';
import { useSharedTranscript } from '@utils/providers/shared-transcript-context.tsx';
import { SharedTranscriptPlayer } from '@components/editors/shared-editor/shared-transcript/shared-transcript-player.tsx';
import { usePrompt } from '@components/editors/confirm/prompt.tsx';
import { useThemeContext } from '@utils/hooks/use-theme-context.ts';
import { useThemeVars } from '@utils/hooks/use-theme-vars.ts';
import { useInterval } from '@utils/hooks/use-interval.tsx';

export default function SharedTranscriptMain() {
  const {
    session,
    document: transcriptDocument,
    autoSave,
    isDirty
  } = useSharedTranscript();

  const { vars, cls } = useThemeVars();
  const { getColour } = useThemeContext();

  useInterval(autoSave, 120 * 1000);

  usePrompt({
    isDirty: isDirty
  });

  return (
    <>
      <SharedTrascriptAbout />

      <div
        className={cn('shadow h-[calc(100vh-100px)] overflow-y-auto pb-16')}
        style={{
          paddingBottom: session?.media_url ? '123px' : '55px'
        }}
      >
        {transcriptDocument && <SharedTranscriptBody />}
      </div>

      {session && session.media_url && (
        <div
          className="fixed left-0 w-full border"
          style={{
            bottom: '48px',
            backgroundColor: getColour('lightestLayer'),
            border: getColour('borderPrimary')
          }}
        >
          <AudioWaveform session={session} />
        </div>
      )}

      <div
        className={cn('fixed bottom-0 left-0 w-full p-1', cls.cardBg)}
        style={vars}
      >
        <SharedTranscriptPlayer session={session} />
      </div>
    </>
  );
}
